<template>
    <div class="flex-page">
        <a-tabs style="flex: 1; background-color: #ffffff; margin: 20px; " default-active-key="1" @change="callback">

            <a-tab-pane key="1" tab="城员信息" force-render>
                <a-form style="hegiht: 100%;" class="form" :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol">
                    <a-form-item label="会员ID">
                        {{ form.id }}
                    </a-form-item>
                    <a-form-item label="微信昵称">
                        {{ form.nickname }}
                    </a-form-item>
                    <a-form-item label="微信头像">
                        <img style="width: 80px;" :src="form.headimgurl" alt="">
                    </a-form-item>

                    <a-form-item label="状态">
                        <div v-if="form.status == 1">正常</div>
                        <div v-if="form.status == 0">未审核</div>
                        <div v-if="form.status == -1">已拒绝</div>
                        <div v-if="form.status == -2">已禁用</div>
                    </a-form-item>

                    <a-form-item label="姓名">
                        <a-input disabled type="text" style="width: 600px" v-model="form.name"></a-input>

                        <a-checkbox disabled class="label-checkbox" v-model="form.name_show">
                            是否显示
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item label="手机号">
                        <a-input disabled type="text" style="width: 600px" v-model="form.mobile"></a-input>

                        <a-checkbox disabled class="label-checkbox" v-model="form.mobile_show">
                            是否显示
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item label="城市">
                        <a-input disabled type="text" style="width: 600px" v-model="form.city"></a-input>

                        <a-checkbox disabled class="label-checkbox" v-model="form.city_show">
                            是否显示
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item label="推荐人">
                        <a-select disabled style="width: 600px" v-model="form.tuijianren">
                            <a-select-option v-for="(item, key) in tuijianren" :key="key" :value="item">{{ item
                            }}</a-select-option>
                        </a-select>

                        <a-checkbox disabled class="label-checkbox" v-model="form.tuijianren_show">
                            是否显示
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item label="身份">
                        <a-checkbox-group disabled style="width: 600px;" v-model="form.shenfen" :options="shenfenList" />

                        <a-checkbox disabled class="label-checkbox" v-model="form.shenfen_show">
                            是否显示
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item label="备注">
                        <a-textarea disabled style="width: 600px" :auto-size="{ minRows: 3, maxRows: 6 }"
                            v-model="form.remarks" />
                        <a-checkbox disabled class="label-checkbox" v-model="form.remarks_show">
                            是否显示
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item label="城员等级">
                        {{ form.level }}
                    </a-form-item>

                    <a-form-item label="城员贡献值">
                        {{ form.admin_gongxian }}
                    </a-form-item>


                </a-form>
            </a-tab-pane>
            <a-tab-pane key="2" tab="活动记录">
                <a-form class="ctrl" layout="inline">

                    <a-form-item>
                        <a-button type="primary" @click="showAddGongxianzhi">添加贡献值</a-button>
                    </a-form-item>


                    <!-- <a-form-item label="活动名称">
                       <a-input style="width: 200px;" v-model="search.huodongName"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" @click="onChange(1)">搜索</a-button>
                    </a-form-item> -->
                </a-form>

                <div style="padding: 15px;">
                    <div class="list">
                        <div class="statistics">共{{ activity.amount }}条</div>
                        <a-table bordered :dataSource="activity.list" :columns="columns" :pagination="false" size="small"
                            :rowKey="(record) => record.id">

                            <template slot="leibie" slot-scope="text, record">
                                <div v-if="record.type == 1">活动获得 </div>
                                <div v-else>管理员添加</div>
                            </template>

                        </a-table>
                        <a-pagination @change="onChange" :total="activity.amount" :defaultPageSize="50"
                            :defaultCurrent="activity.now_page" showQuickJumper class="margin15" />
                    </div>
                </div>

            </a-tab-pane>
            <a-tab-pane key="3" tab="缴费记录">
                <div style="padding: 15px;">
                    <div class="list">
                        <div class="statistics">共{{ jiaofei.amount }}条</div>
                        <a-table bordered :dataSource="jiaofei.list" :columns="jiaofeiColumns" :pagination="false"
                            size="small" :rowKey="(record) => record.id">
                            <template slot="id" slot-scope="text, record">
                                beikechengId_{{ record.id }}
                            </template>
                            <!-- <template slot="daoqishijian" slot-scope="text, record">
                                {{ record.created_at }} ~ {{ record.daoqi_at }}
                            </template> -->

                        </a-table>
                        <a-pagination @change="onChangeJiaofei" :total="jiaofei.amount" :defaultPageSize="50"
                            :defaultCurrent="jiaofei.now_page" showQuickJumper class="margin15" />
                    </div>
                </div>
            </a-tab-pane>

        </a-tabs>


        <a-modal title="添加贡献值" :visible="addGongxianzhi.show" @ok="doAddGongxianzhi" @cancel="cancelAddGongxianzhi">
            <a-form class="" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-form-item label="贡献值">
                    <a-input-number style="width: 300px;" v-model="addGongxianzhi.gongxianzhi" :min="0"></a-input-number>
                </a-form-item>

                <a-form-item label="备注">
                    <a-textarea style="width: 300px;" v-model="addGongxianzhi.remark"></a-textarea>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
  
<style lang="scss" scoped>
.form {
    padding: 40px;
}

.label-checkbox {
    margin-left: 20px;
}
</style>
  
<script>
import moment from 'moment';
export default {
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            form: {},
            tuijianren: [],
            shenfenList: ['贝商', '爱好者', '贝类科研人员'],
            levelList: ['2018城员', '钻石城员', '金城员', '银城员', '游客'],
            columns: [
                {
                    title: "类别",
                    dataIndex: "leibie",
                    scopedSlots: {
                        customRender: "leibie",
                    },
                },
                {
                    title: "活动",
                    dataIndex: "huodong_name",
                },
                {
                    title: "备注",
                    dataIndex: "remark",
                },
                {
                    title: "贡献值",
                    dataIndex: "gongxianzhi",
                },
                {
                    title: "时间",
                    dataIndex: "created_at",
                },
                // {
                //     title: "操作",
                //     dataIndex: "caozuo",
                //     scopedSlots: {
                //         customRender: "caozuo",
                //     },
                // },
            ],
            jiaofeiColumns: [
            {
                    title: "充值ID",
                    scopedSlots: {
                        customRender: "id",
                    },
                },

                {
                    title: "缴费金额",
                    dataIndex: "money",
                },
                {
                    title: "状态",
                    dataIndex: "status",
                },
                {
                    title: "缴费时间",
                    dataIndex: "created_at",
                },
                {
                    title: "到期时间",
                    dataIndex: "daoqi_at",
                },
                // {
                //     title: "操作",
                //     dataIndex: "caozuo",
                //     scopedSlots: {
                //         customRender: "caozuo",
                //     },
                // },
            ],
            id: null,
            activity: {
                amount: 0,
                pages: 1,
                list: [],

                now_page: 1,
                huodongName: ''
            },
            jiaofei: {
                amount: 0,
                pages: 1,
                list: [],
                now_page: 1,
            },
            addGongxianzhi: {
                show: false,
                gongxianzhi: 0,
                remark: ''
            }
        };
    },
    async created() {
        const id = this.$route.query.id;
        this.id = id
        this.getList();
        this.getJiaofeiList();
        const res = await this.$axios.get('/shellCity/getTuijianren')
        if (res.tuijianren) {
            this.tuijianren = res.tuijianren.split('|')
        }

        const r = await this.$axios.get("/shellCity/getDetail?id=" + id);
        if (r.status == 1) {
            r.data.shenfen = JSON.parse(r.data.shenfen)
            this.form = r.data;
            // this.form.shenfenArr = JSON.parse(r.data.shenfen)
            this.form.admin_gongxian_add = 0
        }


    },
    methods: {
        moment,
        async sub() {
            this.$router.push('/shellCity/edit?id=' + this.form.id)
        },
        callback() {

        },
        onChange(e) {
            this.activity.now_page = e;
            this.getList();
        },
        async getList() {
            const params = {
                id: this.id,
                now_pagee: this.activity.now_page,
                huodongName: this.activity.huodongName
            }

            const r = await this.$axios.get("/shellCity/getHuodongJoinList", { params: params });
            this.activity.list = r.list;
            this.activity.amount = r.amount;
        },
        onChangeJiaofei(e) {
            this.jiaofei.now_page = e;
            this.getJiaofeiList();
        },
        showAddGongxianzhi() {
            this.addGongxianzhi.show = true
        },
        async doAddGongxianzhi() {
            const r = await this.$axios.post("/shellCity/doAddGongxianzhi", { id: this.id, gongxianzhi: this.addGongxianzhi.gongxianzhi, remark: this.addGongxianzhi.remark });
            if (r.status == 1) {
                this.getList()
                this.cancelAddGongxianzhi()
            }
        },
        cancelAddGongxianzhi() {
            this.addGongxianzhi = {
                show: false,
                gongxianzhi: 0
            }
        },
        async getJiaofeiList() {
            const params = {
                id: this.id,
                now_pagee: this.jiaofei.now_page
            }
            const r = await this.$axios.get("/shellCity/getJiaofeiList", { params: params });
            this.jiaofei.list = r.list;
            this.jiaofei.amount = r.amount;
        }
    },
};
</script>
